import React from 'react';
import { func_cookieSetting, func_datetime, func_validation, isNumberValid, isStringTrimNotEmpty } from 'functions';

export function useDrillDownReportColumns() {

    function getColumn_dealerCode() {
        let columnClassName = "columns__dealer-code flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Dealer Code",
            id: "dealerCode",
            accessor: "AgentCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_docNo() {
        let columnClassName = "columns__doc-no flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Doc No",
            id: "docNo",
            accessor: "DocNo",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_itemCode() {
        let columnClassName = "columns__item-code flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Item Code",
            id: "itemCode",
            accessor: "ItemCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_docDate() {
        let columnClassName = "table__doc-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Doc Date",
            id: "docDate",
            accessor: "DocDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_description() {
        let columnClassName = "table__description";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Description",
            id: "description",
            accessor: "Description2",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_companyName() {
        let columnClassName = "table__company-name";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Company Name",
            id: "companyName",
            accessor: "CompanyName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_dealerName() {
        let columnClassName = "columns__sales-person-name flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Dealer Name",
            id: "dealerName",
            accessor: "AgentName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_quantity() {
        let columnClassName = "columns__quantitu";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Quantity",
            id: "quantity",
            accessor: "Qty",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 150
        }
    }

    function getColumn_localAmount() {
        let columnClassName = "columns__local-amount";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Local Amount (RM)",
            id: "localAmount",
            accessor: "LocalAmount",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";

                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 175
        }
    }

    return [
        getColumn_dealerCode(),
        getColumn_dealerName(),
        getColumn_companyName(),
        getColumn_docNo(),
        getColumn_itemCode(),
        getColumn_docDate(),
        getColumn_description(),
        getColumn_quantity(),
        getColumn_localAmount(),
    ]
}